import React from "react"
import { View } from "react-native"

export const Spacer = (props) => {
    return <View style={{ height: props.height ?? 20, width: props.width }}></View>
}
